import { createAction } from "redux-actions";

export const LOGIN = "LOGIN";
export const login = createAction(LOGIN);

export const UPDATE_SESSION = "UPDATE_SESSION";
export const updateSession = createAction(UPDATE_SESSION);

export const AUTH0_EXCHANGE_CODE = "AUTH0_EXCHANGE_CODE";
export const Auth0ExchangeCode = createAction(AUTH0_EXCHANGE_CODE);
export const AUTH0_EXCHANGE_CODE_REQUESTED = "AUTH0_EXCHANGE_CODE_REQUESTED";
export const Auth0ExchangeCodeRequested = createAction(AUTH0_EXCHANGE_CODE_REQUESTED);
export const AUTH0_EXCHANGE_CODE_SUCCESS = "AUTH0_EXCHANGE_CODE_SUCCESS";
export const Auth0ExchangeCodeSuccess = createAction(AUTH0_EXCHANGE_CODE_SUCCESS);
export const AUTH0_EXCHANGE_CODE_FAILURE = "AUTH0_EXCHANGE_CODE_FAILURE";
export const Auth0ExchangeCodeFailure = createAction(AUTH0_EXCHANGE_CODE_FAILURE);

export const AUTH0_CREATE_SESSION = "AUTH0_CREATE_SESSION";
export const Auth0CreateSession = createAction(AUTH0_CREATE_SESSION);
export const AUTH0_CREATE_SESSION_REQUESTED = "AUTH0_CREATE_SESSION_REQUESTED";
export const Auth0CreateSessionRequested = createAction(AUTH0_CREATE_SESSION_REQUESTED);
export const AUTH0_CREATE_SESSION_SUCCESS = "AUTH0_CREATE_SESSION_SUCCESS";
export const Auth0CreateSessionSuccess = createAction(AUTH0_CREATE_SESSION_SUCCESS);
export const AUTH0_CREATE_SESSION_FAILURE = "AUTH0_CREATE_SESSION_FAILURE";
export const Auth0CreateSessionFailure = createAction(AUTH0_CREATE_SESSION_FAILURE);

export const SIGNOUT = "SIGNOUT";
export const signout = createAction(SIGNOUT);

export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const signoutSuccess = createAction(SIGNOUT_SUCCESS);

// UpdateUser
export const UPDATE_USER = "UPDATE_USER";
export const UpdateUser = createAction(UPDATE_USER);
export const UPDATE_USER_REQUESTED = "UPDATE_USER_REQUESTED";
export const UpdateUserRequested = createAction(UPDATE_USER_REQUESTED);
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const UpdateUserFailure = createAction(UPDATE_USER_FAILURE);
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UpdateUserSuccess = createAction(UPDATE_USER_SUCCESS);

// UpdateUserPassword
export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
export const UpdateUserPassword = createAction(UPDATE_USER_PASSWORD);
export const UPDATE_USER_PASSWORD_REQUESTED = "UPDATE_USER_PASSWORD_REQUESTED";
export const UpdateUserPasswordRequested = createAction(UPDATE_USER_PASSWORD_REQUESTED);
export const UPDATE_USER_PASSWORD_FAILURE = "UPDATE_USER_PASSWORD_FAILURE";
export const UpdateUserPasswordFailure = createAction(UPDATE_USER_PASSWORD_FAILURE);
export const UPDATE_USER_PASSWORD_SUCCESS = "UPDATE_USER_PASSWORD_SUCCESS";
export const UpdateUserPasswordSuccess = createAction(UPDATE_USER_PASSWORD_SUCCESS);
